import type { ReactNode } from "react";

import { Heading } from "../Heading";

import styles from "./FormHeading.module.scss";

type FormHeadingProps = {
  title?: ReactNode;
} & Record<string, unknown>;

export const FormHeading = ({ title, ...restProps }: FormHeadingProps) =>
  title ? (
    <Heading className={styles.heading} {...restProps}>
      {title}
    </Heading>
  ) : null;
